module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0148.jpg?v=bfae3341";